import Vue from "vue";
import VueRouter from "vue-router";

if (process.env.NODE_ENV === "development") {
    Vue.use(VueRouter);
}

import {
    ROUTER_MODE
} from "../config/app";

// 主页
import Home from "../views/home/index.vue";

//数据管理
import dataManage from "../views/data/dataManage.vue";

//用户管理
import mbUser from "../views/mbUsers/mbUsers.vue";
//积分明细
import integralDetail from "../views/mbUsers/integralDetail.vue";
import Detail from "../views/mbUsers/Detail.vue";
// 管理组相关
import authAdmin from "../views/userManage/admin/authAdmin.vue";
import authRole from "../views/userManage/admin/authRole.vue";
import authPermissionRule from "../views/userManage/admin/authPermissionRule.vue";
// 积分礼品订单
import integralList from "../views/integral/integralList.vue"; // 礼品管理列表页面
import integralDetails from "../views/integral/integralDetails.vue"; // 礼品详情页面
import integralOrderList from "../views/integral/integralOrderList.vue"; // 礼品订单管理列表页面
import integralOrderDetails from "../views/integral/integralOrderDetails.vue"; // 礼品订单管理详情页面
import integralClassify from "../views/integral/integralClassify.vue"; // 礼品分类管理页面
// 消息管理
import messageList from "../views/message/messageList.vue"; // 消息管理列表页面
import messageDetails from "../views/message/messageDetails.vue"; // 消息管理列表页面
import messageEdit from "../views/message/messageEdit.vue"; // 消息管理列表编辑页面
// 商品询价管理
import inquiryList from "../views/inquiry/inquiryList.vue"; // 商品询价管理列表页面
import inquiryDetails from "../views/inquiry/inquiryDetails.vue"; //商品 询价管理列表页面
// 系统设置
import version from "../views/sysSetting/version.vue";
import sysOpinionBack from "../views/sysSetting/sysOpinionBack.vue";
import sysUserGrade from "../views/sysSetting/sysUserGrade.vue";
import comRate from "../views/sysSetting/comRate.vue";
import sysUserIntegral from "../views/sysSetting/userIntegral.vue";
import aboutUs from "../views/sysSetting/aboutUs.vue";
import introduce from "../views/sysSetting/introduce.vue";
import sri from "../views/sysSetting/sri.vue";
import integralrule from "../views/sysSetting/integralrule.vue";
import state from "../views/sysSetting/statement.vue";
import help from "../views/sysSetting/help.vue";
import userAgreement from "../views/sysSetting/userAgreement.vue";
import userPolicy from "../views/sysSetting/userPolicy.vue";
import termsCondition from "../views/sysSetting/termsCondition.vue";
import paymentCopy from "../views/sysSetting/paymentCopy.vue";
//商品管理
import userSearch from "../views/product/userSearch.vue";
import service from "../views/product/service.vue";
import brand from "../views/product/brand.vue";
import brand2 from "../views/product/brand2.vue";
import classify from "../views/product/classify.vue";
import repertory from "../views/product/repertory.vue";
import product from "../views/product/product.vue";

//轮播图管理
import picmanage from "../views/slidepic/slidepic.vue";
//banner管理
import banner from "../views/slidepic/banner.vue";

//运费配置
import subarea from "../views/freight/subarea.vue";
import cunsubarea from "../views/freight/cunsubarea.vue";
import freight from "../views/freight/freight.vue";

//订单管理
import saleorder from "../views/order/saleOrder.vue";
import aftersaleorder from "../views/order/afterSaleOrder.vue";
import otherOrder from "../views/order/otherOrder.vue";
import otherOrderForm from "../views/order/otherOrderForm.vue";
import serviceorder from "../views/order/serviceOrder.vue";
import sharexkorder from "../views/order/shareXkOrder.vue";

// 通用询价管理
import generalinquiryList from "../views/generalinquiry/generalinquiryList.vue";
import generalinquiryDetails from "../views/generalinquiry/generalinquiryDetails.vue";

const err401 = r =>
    require.ensure([], () => r(require("../views/error/err401.vue")), "home");
const err404 = r =>
    require.ensure([], () => r(require("../views/error/err404.vue")), "home");
const login = r =>
    require.ensure([], () => r(require("../views/login/index.vue")), "home");
const main = r =>
    require.ensure([], () => r(require("../views/home/main.vue")), "home");

// 注意 权限字段 authRule （严格区分大小写）
export const constantRouterMap = [{
        path: "*",
        component: err404,
        hidden: true
    },
    {
        path: "/401",
        component: err401,
        name: "401",
        hidden: true
    },
    {
        path: "/404",
        component: err404,
        name: "404",
        hidden: true
    },
    {
        path: "/500",
        component: err404,
        name: "500",
        hidden: true
    },
    {
        path: "/login",
        component: login,
        name: "登录",
        hidden: true
    },
    {
        path: "/",
        component: Home,
        redirect: "/home",
        name: "首页",
        hidden: true
    },
    {
        path: "/home",
        component: Home,
        redirect: "/home/main",
        icon: "shouye",
        name: "霍夫曼后台管理系统",
        noDropdown: true,
        children: [{
            path: "main",
            component: main
        }]
    }
];

export default new VueRouter({
    mode: ROUTER_MODE,
    routes: constantRouterMap,
    strict: process.env.NODE_ENV !== "production"
});

var routerMap = [{
        path: "/data",
        component: Home,
        icon: "ico_data",
        name: "数据管理",
        meta: {
            authRule: ["hp/gehp/index"]
        },
        children: [{
            path: "",
            component: dataManage
        }],
        noDropdown: true
    },

    {
        path: "/mbuser",
        redirect: "",
        component: Home,
        icon: "yonghu",
        name: "用户管理",
        meta: {
            authRule: ["mbuser"]
        },
        noDropdown: true,
        children: [{
            path: "",
            component: mbUser
        }]
    },
    {
        path: "/mbUser/integralDetail",
        redirect: "/mbUser/integralDetail",
        component: Home,
        name: "用户管理 /积分明细 ",
        hidden: true,
        children: [{
            path: "",
            component: integralDetail
        }]
    },
    {
        path: "/mbUser/Detail",
        redirect: "/mbUser/Detail",
        component: Home,
        name: "用户管理 /详情 ",
        hidden: true,
        children: [{
            path: "",
            component: Detail
        }]
    },
    // {
    //     path: "/pmPharmacy/pharmacyDrug",
    //     redirect: "/pmPharmacy/pharmacyDrug",
    //     component: Home,
    //     icon: "yonghu",
    //     name: "用户管理",
    //     children: [
    //         {
    //             path: "",
    //             component: pmPharmacyDrug
    //         }
    //     ],
    //     noDropdown: true
    // },
    // {
    //     path: "/mbUser",
    //     redirect: "/mbUser/mbUser",
    //     component: Home,
    //     icon: "yonghu",
    //     name: "用户管理",
    //     meta: {
    //         authRule: ["mb_user"]
    //     },
    //     noDropdown: true
    // },
    {
        path: "/order",
        redirect: "saleorder",
        component: Home,
        icon: "dingdan",
        name: "订单管理",
        meta: {
            authRule: ["order"]
        },
        children: [{
                path: "otherOrder",
                component: otherOrder,
                name: "已执行订单管理",
                meta: {
                    authRule: ["order/aftersaleorder/index"]
                }
            },
            {
                path: "otherOrderForm",
                component: otherOrderForm,
                hidden: true,
                name: "已执行订单管理",
                meta: {
                    authRule: ["order/aftersaleorder/index"]
                }
            },

            {
                path: "saleorder",
                component: saleorder,
                name: "订单管理",
                meta: {
                    authRule: ["order/saleorder/index"]
                }
            },

            {
                path: "aftersaleorder",
                component: aftersaleorder,
                name: "售后工单管理",
                meta: {
                    authRule: ["order/aftersaleorder/index"]
                }
            },
            {
                path: "serviceorder",
                component: serviceorder,
                name: "服务订单管理",
                meta: {
                    authRule: ["order/serveorder/index"]
                }
            },
            {
                path: "sharexkorder",
                component: sharexkorder,
                name: "分享逍客订单",
                meta: {
                    authRule: ["order/serveorder/index"]
                }
            }
        ]
    },
    {
        path: "/product",
        redirect: "product",
        component: Home,
        icon: "shangpinbiaoqian",
        name: "商品管理",
        meta: {
            authRule: ["product"]
        },
        children: [
            // {
            //     path: "userSearch",
            //     component: userSearch,
            //     name: "标签管理",
            //     meta: {
            //         authRule: ["product/userSearch/index"]
            //     }
            // },
            {
                path: "service",
                component: service,
                name: "服务管理",
                meta: {
                    authRule: ["product/service/index"]
                }
            },
            {
                path: "brand",
                component: brand,
                name: "应用场景管理",
                meta: {
                    authRule: ["product/brand/index"]
                }
            }, {
                path: "brand2",
                component: brand2,
                name: "品牌管理",
                meta: {
                    authRule: ["product/brand2/index"]
                }
            },
            {
                path: "classify",
                component: classify,
                name: "分类管理",
                meta: {
                    authRule: ["product/classify/index"]
                }
            },
            {
                path: "specifications",
                component: () => import('@/views/product/specifications.vue'),
                name: "数据规格字段管理",
                meta: {
                    authRule: ["product/specifications/index"]
                }
            },
            {
                path: "product",
                component: product,
                name: "商品管理",
                meta: {
                    authRule: ["product/commodity/index"]
                }
            },
            {
                path: "prview",
                name: "商品预览",
                hidden: true,
                component: () => import('@/views/product/preview')
            },
            {
                path: "repertory",
                component: repertory,
                name: "库存管理",
                meta: {
                    authRule: ["product/repertory/index"]
                }
            }
        ]
    },
    {
        path: "/slidepic/picmanage",
        redirect: "/slidepic/picmanage",
        component: Home,
        icon: "houtailunbo",
        name: "轮播图管理",
        meta: {
            authRule: ["slidepic/index"]
        },
        noDropdown: true,
        children: [{
            path: "",
            component: picmanage
        }]
    },

    // {
    //     path: "/slidepic/banner",
    //     redirect: "/slidepic/banner",
    //     component: Home,
    //     icon: "houtailunbo",
    //     name: "banner管理",
    //     meta: {
    //         authRule: ["slidepic/index"]
    //     },
    //     noDropdown: true,
    //     children: [
    //         {
    //             path: "",
    //             component: banner
    //         }
    //     ]
    // },
    // {
    //     path: "/freight",
    //     redirect: "freight",
    //     component: Home,
    //     icon: "yunfei",
    //     name: "运费配置",
    //     meta: {
    //         authRule: ["freight"]
    //     },
    //     children: [
    //         {
    //             path: "subarea",
    //             component: subarea,
    //             name: "分区管理",
    //             meta: {
    //                 authRule: ["freight/subarea/index"]
    //             }
    //         },
    //         {
    //             path: "cunsubarea",
    //             component: cunsubarea,
    //             name: "国家分区管理",
    //             meta: {
    //                 authRule: ["freight/cunsubarea/index"]
    //             }
    //         },
    //         {
    //             path: "freight",
    //             component: freight,
    //             name: "运费设置",
    //             meta: {
    //                 authRule: ["freight/expprice/index"]
    //             }
    //         }
    //     ]
    // },
    {
        path: "/sysSetting",
        redirect: "version",
        component: Home,
        icon: "shezhi",
        name: "系统设置",
        meta: {
            authRule: ["system"]
        },
        children: [{
                path: "sysOpinionBack",
                component: sysOpinionBack,
                name: "意见反馈",
                meta: {
                    authRule: ["system/feedback/index"]
                }
            },
            // {
            //     path: "sysUserGrade",
            //     component: sysUserGrade,
            //     name: "用户等级设置",
            //     meta: {
            //         authRule: ["system/usergrade/index"]
            //     }
            // },
            // {
            //     path: "sysUserIntegral",
            //     component: sysUserIntegral,
            //     name: "积分设置",
            //     meta: {
            //         authRule: ["system/userintegral/index"]
            //     }
            // },
            {
                path: "version",
                component: version,
                name: "版本信息",
                meta: {
                    authRule: ["system/version/index"]
                }
            },
            {
                path: "comRate",
                component: comRate,
                name: "汇率设置",
                meta: {
                    authRule: ["system/rate/index"]
                }
            },
            {
                path: "aboutUs",
                component: aboutUs,
                name: "关于我们",
                meta: {
                    authRule: ["system/aboutus/index"]
                }
            },
            {
                path: "userAgreement",
                component: () => import('@/views/sysSetting/userAgreement.vue'),
                name: "用户协议",
                meta: {
                    authRule: ["system/treaty/index"]
                }
            },
            {
                path: "userPolicy",
                component: userPolicy,
                name: "隐私政策",
                meta: {
                    authRule: ["system/treaty/index"],
                }
            },
            {
                path: "tiaokuan",
                component: termsCondition,
                name: "条款和条件",
                meta: {
                    authRule: ["system/treaty/index"]
                }
            },
            {
                path: "introduce",
                component: introduce,
                name: "公司介绍",
                meta: {
                    authRule: ["system/introduce/index"]
                }
            },
            {
                path: "sri",
                component: sri,
                name: "如何查找序列号",
                meta: {
                    authRule: ["system/sri/index"]
                }
            },
            {
                path: "integralrule",
                component: integralrule,
                name: "积分说明",
                meta: {
                    authRule: ["system/integral/index"]
                }
            },
            {
                path: "statemange",
                component: state,
                name: "国别管理",
                meta: {
                    authRule: ["system/state/index"]
                }
            },
            {
                path: "paymentCopy",
                component: paymentCopy,
                name: "付款文案",
                // meta: {
                //     authRule: ["system/state/index"]
                // }
            },
            // {
            //     path: "help",
            //     component: help,
            //     name: "帮助详情",
            //     meta: {
            //         authRule: ["system/help/index"]
            //     }
            // }
        ]
    },
    {
        path: "/userManage",
        redirect: "/userManage/authAdmin",
        component: Home,
        icon: "ic_opt_feature",
        name: "权限管理",
        meta: {
            authRule: ["authority"]
        },
        children: [{
                path: "authAdmin",
                component: authAdmin,
                name: "管理员管理",
                meta: {
                    authRule: ["admin/auth/admin/index"]
                }
            },
            {
                path: "authRole",
                component: authRole,
                name: "角色管理",
                meta: {
                    authRule: ["admin/auth/role/index"]
                }
            }
        ]
    },
    {
        path: "/integral",
        redirect: "/integral/list",
        component: Home,
        icon: "yewutongjifenxiguize",
        name: "积分礼品订单",
        meta: {
            authRule: ["integral"]
        },
        children: [{
                path: "list",
                component: integralList,
                name: "礼品管理",
                meta: {
                    authRule: ["integral/integralList"]
                }
            },
            {
                path: "details",
                //component: integralDetails,
                name: "礼品管理详情",
                hidden: true,
                component: () => import('@/views/integral/integralDetails')
                /*meta: {
                    authRule: ["integral/integralDetails"]
                }*/
            },
            {
                path: "orderList",
                component: integralOrderList,
                name: "礼品订单管理",
                meta: {
                    authRule: ["integral/integralOrderList"]
                }
            },
            {
                path: "orderDetails",
                //component: integralOrderDetails,
                name: "礼品订单详情",
                hidden: true,
                component: () => import('@/views/integral/integralOrderDetails')
               /* meta: {
                    authRule: ["integral/integralOrderDetails"]
                }*/
            },
            {
                path: "sysUserIntegral",
                component: sysUserIntegral,
                name: "积分设置",
                meta: {
                    authRule: ["system/userintegral/index"]
                }
            },
            {
                path: "classify",
                component: integralClassify,
                name: "礼品分类管理",
                meta: {
                    authRule: ["integral/integralClassify"]
                }
            }
        ]
    },
    {
        path: "/message",
        redirect: "/message/list",
        component: Home,
        icon: "xiaoxi",
        name: "消息管理",
        meta: {
            authRule: ["message"]
        },
        children: [{
                path: "list",
                component: messageList,
                name: "消息管理",
                meta: {
                    authRule: ["message/messageList"]
                }
            },
            {
                path: "details",
                //component: messageDetails,
                name: "消息详情",
                hidden: true,
                component: () => import('@/views/message/messageDetails')
               /* meta: {
                    authRule: ["message/messageDetails"]
                }*/
            },
            {
                path: "edit",
                component: messageEdit,
                name: "消息编辑",
                hidden: true,
                meta: {
                    authRule: ["message/messageEdit"]
                }
            }
        ]
    },
    {
        path: "/inquiry",
        redirect: "/inquiry/list",
        component: Home,
        icon: "beizhu",
        name: "商品询价管理",
        meta: {
            authRule: ["inquiry"]
        },
        children: [{
                path: "list",
                component: inquiryList,
                name: "商品询价管理",
                meta: {
                    authRule: ["inquiry/inquiryList"]
                }
            },
            {
                path: "details",
                component: inquiryDetails,
                name: "商品询价详情",
                hidden: true,
                //component: () => import('@/views/inquiry/inquiryDetails')
                // meta: {
                //     authRule: ["inquiry/inquiryDetails"]
                // }
            }
        ]
    },
    {
        path: "/generalinquiry",
        redirect: "/generalinquiry/list",
        component: Home,
        icon: "beizhu",
        name: "通用询价管理",
        meta: {
            authRule: ["generalinquiry"]
        },
        children: [{
                path: "list",
                component: generalinquiryList,
                name: "通用询价管理",
                meta: {
                    authRule: ["generalinquiry/generalinquiryList"]
                }
            },
            {
                path: "details",
                //component: generalinquiryDetails,
                name: "通用询价详情",
                hidden: true,
                component: () => import('@/views/generalinquiry/generalinquiryDetails')
                /*meta: {
                    authRule: ["generalinquiry/generalinquiryDetails"]
                }*/
            }
        ]
    }
];

// 本地开发环境开放权限设置 仅限开发人员使用
if (process.env.NODE_ENV === "development") {
    routerMap[routerMap.length - 1].children.push({
        path: "authPermissionRule",
        component: authPermissionRule,
        name: "权限设置",
        meta: {
            authRule: ["admin/auth/permission_rule/index"]
        }
    });
}

export const asyncRouterMap = routerMap;
